import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-solution',
  templateUrl: './solution.component.html',
  styleUrls: ['./solution.component.scss'],
})
export class SolutionComponent implements OnInit {

  @Input() solution : string;
  
  visicode : boolean = false;
  nombtvisi : string = "Show"; 
  

  constructor() { }

  
  clicksolution() {
    this.visicode = !this.visicode;
  if(this.visicode)
    this.nombtvisi = "hide";
  else
    this.nombtvisi = "show";

}
  
  ngOnInit() {}

}
